import { render, staticRenderFns } from "./MenuBuilderPage.vue?vue&type=template&id=de38db5c&scoped=true&"
import script from "./MenuBuilderPage.vue?vue&type=script&lang=js&"
export * from "./MenuBuilderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de38db5c",
  null
  
)

export default component.exports